import UnaffectedUserList from './UnaffectedUserList';

export default UnaffectedUserList;
